import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Icon, Popconfirm, Table } from 'antd';
import moment from 'moment';

import * as consultantController from '../../../../../../services/api/consultant';
import './ConsultantList.scss';

export class ConsultantList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataSource: [],
            selectedRowKeys: []
        }
    }

    fetchData() {
        consultantController.getConsultants()
            .then((res) => res.json())
            .then((json) => {
                this.setState({ dataSource: json })
            })
            .catch((err) => console.log(err))
    }

    handleRemove() {
        const { selectedRowKeys } = this.state;
        
        this.setState({ isLoading: true });
        
        consultantController.deleteConsultants(selectedRowKeys)
            .then((res) => res.json())
            .then((json) => {
                this.fetchData();
            })
            .catch((err) => console.log(err))
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState) {
        const { isActive } = this.props;

        if (isActive && isActive !== prevProps.isActive)
            this.fetchData();
    }

    render() {
        const { history } = this.props;
        const { selectedRowKeys, dataSource } = this.state;
        const isRowSelected = selectedRowKeys.length !== 0;

        const columns = [{
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            sorter: (a, b) => a.id - b.id,
        }, {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => a.name.localeCompare(b.name),
        }, {
            title: 'Username',
            dataIndex: 'username',
            key: 'username',
            sorter: (a, b) => a.username.localeCompare(b.username),
        }, {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            sorter: (a, b) => a.email.localeCompare(b.email),
        }, {
            title: 'is Admin?',
            dataIndex: 'is_admin',
            key: 'is_admin',
            align: 'center',
            width: 120,
            render: (isAdmin) => isAdmin ? <Icon type="check" /> : <Icon type="close" />,
            sorter: (a, b) => a.id - b.id,
        }, {
            title: 'Joined at',
            dataIndex: 'joined_at',
            key: 'joined_at',
            align: 'center',
            width: 120,
            render: (text) => moment(text).format('YYYY-MM-DD'),
            sorter: (a, b) => new Date(a.joined_at) - new Date(b.joined_at),
        }, {
            title: 'Edit',
            dataIndex: 'edit',
            key: 'edit',
            align: 'center',
            width: 80,
            render: (text, record) => (<Icon className="icon-btn" type="edit" onClick={() => history.push(`/dashboard/admin/consultant/${record.id}`)} />)
        }];

        return (
            <div className="DataList">
                <div className="table-btn-gp">
                    <div className="table-btn-gp-left">
                        <button onClick={(e) => history.push('/dashboard/admin/consultant/new')}>
                            <Icon type="plus"/>
                            Create
                        </button>
                    </div>
                    <div className="table-btn-gp-right">
                        <Popconfirm 
                            placement="bottom"
                            title="This action is irreversible, are you sure?" 
                            onConfirm={(e) => this.handleRemove()} 
                            okText="Yes" 
                            cancelText="No"
                        >
                            <button disabled={!isRowSelected}>
                                <Icon type="minus"/>
                                Remove
                            </button>
                        </Popconfirm>
                    </div>
                </div>
                <Table
                    size="small"
                    rowKey="id"
                    columns={columns}
                    dataSource={dataSource}
                    rowSelection={{selectedRowKeys, onChange: (selectedRowKeys) => this.setState({selectedRowKeys})}} 
                />
            </div>
        );
    }
}

export default withRouter(ConsultantList);


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ConsultantPage/scenes/ConsultantList/ConsultantList.js